import React from "react";

interface LoaderProps {
  color: string;
  size?: string;
  style?: string;
}

const Loader: React.FC<LoaderProps> = ({ color, size, style }) => {
  return (
    <div className="flex justify-center items-center" data-testid="loader">
      <div
        className={`${
          size == "lg" ? "w-20 h-20" : size == "xs" ? "w-2.5 h-2.5" : "w-5 h-5"
        } border-2 border-t-transparent rounded-full animate-spin ${style}`}
        style={{ borderColor: `${color} transparent transparent transparent` }}
      ></div>
    </div>
  );
};

export default Loader;
